import _uniqueId from "lodash/uniqueId";
import spreadsheetsApiClient from '../../lib/spreadsheetsApiClient';
import * as types from '../types';
const showHint = _ref => {
  let {
    environment,
    exerciseId,
    message,
    xpCost
  } = _ref;
  return async dispatch => {
    dispatch({
      exerciseId,
      message,
      messageId: _uniqueId(),
      type: types.SHOW_HINT,
      xpCost
    });
    await spreadsheetsApiClient(environment).getHint(exerciseId);
  };
};
export default showHint;